/** Lógica pura del opt-in de notificaciones push. */

import type { KeyValueStorage } from "./installPromptState";

export const PUSH_PROMPT_DISMISSED_KEY = "t123-push-prompt-dismissed-at";
export const PUSH_PROMPT_SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;

export function shouldShowPushPrompt(storage: KeyValueStorage, now: number): boolean {
  const raw = storage.getItem(PUSH_PROMPT_DISMISSED_KEY);
  if (!raw) return true;
  const dismissedAt = Number(raw);
  if (!Number.isFinite(dismissedAt)) return true;
  return now - dismissedAt >= PUSH_PROMPT_SNOOZE_MS;
}

export function markPushPromptDismissed(storage: KeyValueStorage, now: number): void {
  storage.setItem(PUSH_PROMPT_DISMISSED_KEY, String(now));
}

/** applicationServerKey: el navegador exige la llave pública VAPID en bytes. */
export function urlBase64ToUint8Array(base64Url: string): Uint8Array {
  const padding = "=".repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

export type PushAvailability = "unsupported" | "ios-needs-install" | "blocked" | "ready";

export function derivePushAvailability(input: {
  supported: boolean;
  permission: NotificationPermission;
  ios: boolean;
  standalone: boolean;
}): PushAvailability {
  // En iOS sin instalar, PushManager ni existe: el estado útil es guiar a
  // instalar, no "no soportado".
  if (input.ios && !input.standalone) return "ios-needs-install";
  if (!input.supported) return "unsupported";
  if (input.permission === "denied") return "blocked";
  return "ready";
}
